import { BaseSalary } from './base-salary.model';
import { JobLocation } from './job-location.model';
import { Address } from './address-with-country.model';
import { Country } from './country-model';

export class JobPosting {
    '@context': string;
    '@type': string;
    title: string;
    description: string;
    contactInformation: string;
    datePosted: string;
    validThrough: string;
    employmentType: string;
    industry: string[];
    salaryCurrency: string;
    jobLocation: JobLocation;
    baseSalary: BaseSalary;

    constructor(title: string,
        description: string,
        contactInformation: string,
        datePosted: string,
        validThrough: string,
        employmentType: string,
        industry: string[],
        salaryCurrency: string,
        salaryValue: string,
        addressRegion: string, addressLocality: string, postalCode: string, streetAddress: string,
        countryName: string) {

        this['@context'] = 'http://schema.org';
        this['@type'] = 'JobPosting';
        this.title = title;
        this.description = description;
        this.contactInformation = contactInformation
        this.datePosted = datePosted;
        this.validThrough = validThrough;
        this.employmentType = employmentType;
        this.industry = industry;
        this.salaryCurrency = salaryCurrency;

        this.jobLocation = new JobLocation(
            new Address(
                new Country(countryName),
                addressRegion,
                addressLocality,
                postalCode,
                streetAddress)
        );

        this.baseSalary = new BaseSalary(salaryCurrency, salaryValue);
    }
}
